import React, { Component } from 'react';
import ContactUsComponent from '../../_Componants/Contactus/ContactUs';

class ContactUs extends Component{
    render(){
        return (
            <div>
                <ContactUsComponent/>
            </div>
        )
    }
}

export default ContactUs;